import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`
    :root {
        // Paleta tirada do logo da Bravoro: grafite, laranja e papel
        --ink: #373535;
        --text: #5A5756;
        --paper: #FFFFFF;
        --paper-2: #F6F5F3;
        --line: #DEDBD8;
        --draft: #B5B1AD; // traço do desenho
        --draft-soft: #DAD7D3;
        --signal: #DC6539;
        --signal-deep: #B4481F; // laranja com contraste para texto
        --signal-line: #E9A688;
        --signal-tint: #FDF1EB;
        --signal-tint-2: #F9DDD0;

        // Nomes antigos, ainda usados por Header, páginas legais e formulário
        --background-dominant: var(--paper);
        --background-secondary: var(--paper-2);
        --accent-primary: var(--ink);
        --accent-hover: var(--signal-deep);
        --text-primary: var(--ink);
        --text-secondary: var(--text);
        --text-muted: #7D7977;
        --border-color: var(--line);
        --shadow-sm: 0 1px 2px rgba(55, 53, 53, 0.08);
        --shadow-md: 0 6px 18px -8px rgba(55, 53, 53, 0.25);
        --shadow-lg: 0 18px 40px -18px rgba(55, 53, 53, 0.35);
        --gradient-primary: var(--paper);
        --gradient-secondary: var(--paper-2);
        --primary-color: var(--ink);
        --secondary-color: var(--signal-deep);
    }

    body,
    html,
    a {
        font-family: 'Archivo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: var(--background-dominant);
        color: var(--text-secondary);
        overflow-x: hidden;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Archivo', sans-serif;
        font-stretch: 112%;
        color: var(--text-primary);
        line-height: 1.15;
        margin-bottom: 1rem;
        font-weight: 600;
    }
    
    h1 {
        font-size: 3.5rem;
        letter-spacing: -0.5px;
        @media only screen and (max-width: 768px) {
          font-size: 2.75rem;
        }
    }
    
    h2 {
        font-size: 2.5rem;
        @media only screen and (max-width: 768px) {
          font-size: 2rem;
        }
    }
    
    h3 {
        font-size: 1.5rem;
    }

    p {
        font-size: 1.125rem;        
        line-height: 1.7;
        margin-bottom: 1.5rem;
    }

    a {
        text-decoration: none;
        outline: none;
        color: var(--accent-primary);
        transition: color 0.3s ease;

        &:hover {
            color: var(--accent-hover);
        }
    }
    
    button {
        font-family: 'Archivo', sans-serif;
        font-weight: 600;
        transition: all 0.3s ease;
        cursor: pointer;
    }
    
    :focus-visible {
        outline: 2px solid var(--signal-deep);
        outline-offset: 3px;
    }

    .ant-drawer-content-wrapper {
        background-color: var(--background-dominant) !important;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        padding: 2rem;
        background-color: var(--background-dominant);
    }

    .ant-drawer-header {
        background-color: var(--background-dominant) !important;
        border-bottom-color: var(--border-color) !important;
    }

    .ant-drawer-close {
        color: var(--text-primary) !important;
    }
`;
